/**
 * Флот
 */
class Fleet {
    constructor() {
        this.seas = document.querySelectorAll('.js-fleet-sea');
        this.stats = document.querySelectorAll('.js-fleet-stat');

        if (this.seas.length && this.stats.length) {
            this.bindAreaHover();
            this.bindAreaClickMobile();
        }
    }


    /**
     * Ховер на десктопах
     */
    bindAreaHover() {
        if (App.mobile) return;

        this.seas.forEach(sea => {
            sea.addEventListener('mouseenter', () => {
                this.changeStatistic(sea.getAttribute('data-id'));
            });

            sea.addEventListener('mouseleave', () => {
                this.changeStatistic();
            });
        });
    }

    /**
     * Клик на тачах
     */
    bindAreaClickMobile() {
        if (!App.mobile) return;

        this.seas.forEach(sea => {
            sea.addEventListener('click', () => {
                this.changeStatistic(sea.getAttribute('data-id'));
            });
        });
    }


    /**
     * Переключаем блоки статистики
     * (Если ничего не выбрано, выделяем Охотское море)
     */
    changeStatistic(id = 1) {
        this.seas.forEach(s => {
            if (s.getAttribute('data-id') === id) {
                s.classList.add('_is-active');
            } else {
                s.classList.remove('_is-active');
            }
        });

        this.stats.forEach(s => {
            if (s.getAttribute('data-id') === id) {
                s.classList.add('_is-active');
            } else {
                s.classList.remove('_is-active');
            }
        });
    }
}

if (document.querySelector('html.page-fleet')) {
    new Fleet();
}



// WEBPACK FOOTER //
// ./_src/js/Fleet.js